/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Loginwelcomemessage2Inputs */

const en_auth_loginwelcomemessage2 = /** @type {(inputs: Auth_Loginwelcomemessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back, please sign in to continue`)
};

/**
* | output |
* | --- |
* | "Welcome back, please sign in to continue" |
*
* @param {Auth_Loginwelcomemessage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_loginwelcomemessage2 = /** @type {((inputs?: Auth_Loginwelcomemessage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Loginwelcomemessage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_loginwelcomemessage2(inputs)
});
export { auth_loginwelcomemessage2 as "auth_loginWelcomeMessage" }